export default "__VITE_ASSET__12_d1F81__"